// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationBar_container__UEvUA {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: linear-gradient(135deg, #3e176a57, #4f1380);
  box-shadow: 0 0 20px rgba(160, 120, 255, 0.5), 0 6px 24px rgba(100, 60, 190, 0.35);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  z-index: 1000;
}

.NavigationBar_icon__7AD93 {
  width: 90px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.NavigationBar_icon__7AD93:focus {
  outline: none;
  box-shadow: none;
}

.NavigationBar_icon__7AD93 svg {
  width: 50%;
  height: 50%;
  color: rgba(255, 255, 255, 0.4);
  transition: inherit;
}

.NavigationBar_icon__7AD93:active svg {
  transform: scale(1.1);
  color: #a66cff;
}

.NavigationBar_active__xbJJt svg {
  color: #a66cff;
  text-shadow: 0 0 8px rgba(166, 108, 255, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NavigationBar/NavigationBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,uDAAuD;EACvD,kFAAkF;EAClF,8CAA8C;EAC9C,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,UAAU;EACV,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  background: linear-gradient(135deg, #3e176a57, #4f1380);\n  box-shadow: 0 0 20px rgba(160, 120, 255, 0.5), 0 6px 24px rgba(100, 60, 190, 0.35);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  z-index: 1000;\n}\n\n.icon {\n  width: 90px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.3s ease, transform 0.3s ease;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n}\n\n.icon:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.icon svg {\n  width: 50%;\n  height: 50%;\n  color: rgba(255, 255, 255, 0.4);\n  transition: inherit;\n}\n\n.icon:active svg {\n  transform: scale(1.1);\n  color: #a66cff;\n}\n\n.active svg {\n  color: #a66cff;\n  text-shadow: 0 0 8px rgba(166, 108, 255, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavigationBar_container__UEvUA`,
	"icon": `NavigationBar_icon__7AD93`,
	"active": `NavigationBar_active__xbJJt`
};
export default ___CSS_LOADER_EXPORT___;
